module.exports = __webpack_public_path__ + "media/images/logos/twint-ca0506243d9bb3a9a7ea39be2473019f.svg";